import axios from "@/app/Axios";

class Reposiciones {

    async listaresarcimientos() {
        try {
            const response = await axios.get("/resarcimiento/pistolaresarcimientolista");
            console.log("Respuestas del Servicio", response);
            return response.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //EJERCITO
    async listaresarcimientosget() {
        try {
            const response = await axios.get("/ejercito/pistolaresarcimientoget");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //AEREA PISTOLA
    async listaresarcimientosgetaerea() {
        try {
            const response = await axios.get("/aerea/pistolaresarcimientoget");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //ARMADA PISTOLA
    async listaresarcimientosgetarmada() {
        try {
            const response = await axios.get("/armada/pistolaresarcimientoget");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //EJERCITO CUCHILLO
    async listaresarcimientoscuchilloget() {
        try {
            const response = await axios.get("/ejercito/cuchilloresarcimientoget");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //AEREA CUCHILLO
    async listaresarcimientoscuchillogetaerea() {
        try {
            const response = await axios.get("/aerea/cuchilloresarcimientoget");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //ARMADA CUCHILLO
    async listaresarcimientoscuchillogetarmada() {
        try {
            const response = await axios.get("/armada/cuchilloresarcimientoget");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //EJERCITO
    async listaresarcimientossableget() {
        try {
            const response = await axios.get("/ejercito/sableresarcimientoget");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //AEREA
    async listaresarcimientossablegetaerea() {
        try {
            const response = await axios.get("/aerea/sableresarcimientoget");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //ARMADA
    async listaresarcimientossablegetarmada() {
        try {
            const response = await axios.get("/armada/sableresarcimientoget");
            console.log("Respuestas del Servicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async savePistolaResarcimiento(pistolapost) {
        try {
            const response = await axios.post("/resarcimiento/pistolaresarcimientoregistro", pistolapost)
            console.log("Esta es respuesta:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async savePistolaCargadorResarcimiento(pistolapost) {
        try {
            const response = await axios.post("/resarcimiento/pistolacargadorresarcimientoregistro", pistolapost)
            console.log("Esta es respuesta:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async saveCuchilloResarcimiento(cuchillopost) {
        try {
            const response = await axios.post("/resarcimiento/cuchilloresarcimientoregistro", cuchillopost)
            console.log("Esta es respuesta:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async saveSableResarcimiento(cuchillopost) {
        try {
            const response = await axios.post("/resarcimiento/sableresarcimientoregistro", cuchillopost)
            console.log("Esta es respuesta:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    //
    async saveResarcimientoPistola(armaspost) {
        try {
            const response = await axios.post("/certificados/certificadosregistro", armaspost)
            console.log("Esta es la respuesta del registro del certificado:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
//EJERCITO PISTOLA
    async listaresarcimientopistolaejercito() {
        try {
            const response = await axios.get("/ejercito/pistoladotacionget");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //AEREA PISTOLA
    async listaresarcimientopistolaaerea() {
        try {
            const response = await axios.get("/aerea/pistoladotacionget");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //ARMADA PISTOLA
    async listaresarcimientopistolaarmada() {
        try {
            const response = await axios.get("/armada/pistoladotacionget");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //EJERCITO CUCHILLO
    async listaresarcimientocuchilloejercito() {
        try {
            const response = await axios.get("/ejercito/cuchillodotacionget");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //AEREA CUCHILLO
    async listaresarcimientocuchilloaerea() {
        try {
            const response = await axios.get("/aerea/cuchillodotacionget");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //ARMADA CUCHILLO
    async listaresarcimientocuchilloarmada() {
        try {
            const response = await axios.get("/armada/cuchillodotacionget");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //EJERCITO SABLES
    async listaresarcimientosableejercito() {
        try {
            const response = await axios.get("/ejercito/sabledotacionget");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
//AEREA SABLES
async listaresarcimientosableaerea() {
    try {
        const response = await axios.get("/aerea/sabledotacionget");
        console.log("Es una lista de Servicion", response);
        return response.data.data;
    } catch (error) {
        console.log(error);
        console.log(error.response.data);
        const errorData = error.response.data;
        return errorData;
    }
}
//ARMADA SABLES
async listaresarcimientosablearmada() {
    try {
        const response = await axios.get("/armada/sabledotacionget");
        console.log("Es una lista de Servicion", response);
        return response.data.data;
    } catch (error) {
        console.log(error);
        console.log(error.response.data);
        const errorData = error.response.data;
        return errorData;
    }
}
    

}

export default Reposiciones;